'use client';

import { motion } from 'framer-motion';

// Definiere einen Typ für ein einzelnes Stat-Element
type Stat = {
  number: string;
  label: string;
};

interface StatsSectionProps {
  stats: Stat[];  // Verwendung des eigenständigen Typs
}

export function StatsSection({ stats }: StatsSectionProps) {
  return (
    <motion.div
      className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 1.4 }}
    >
      {stats.map((stat, index) => (
        <motion.div
          key={index}
          className="text-center p-6 bg-[rgba(12,11,50,0.2)] backdrop-blur-sm rounded-xl"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 1.5 + (index * 0.1) }}
          whileHover={{ y: -5, transition: {delay: 0} }}
        >
          <div className="text-3xl md:text-4xl font-bold text-[#88ffff] mb-2">{stat.number}</div>
          <div className="text-white/70">{stat.label}</div>
        </motion.div>
      ))}
    </motion.div>
  );
}